import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import React from "react";
import globalUtils from "../../utils/globalUtils";

const AvatarView = ({ photo }: any) => {
  return (
    <div>
      {globalUtils.isPhotoExist(photo) ? (
        <Avatar size="small" src={photo} />
      ) : (
        <Avatar size="small" icon={<UserOutlined />} />
      )}
    </div>
  );
};

export default AvatarView;
